import React from 'react'
import moment from 'moment'
import { Col, Grid, Row } from 'react-bootstrap'
import { getLastMissionDateLabel } from '../../util'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { Checkbox } from '../../../../../../Components/Form/Checkbox'
import { numberFormatter } from '../../../../../../Utils/Formatters'
import { StarRating } from '../../../../../../Components/StarRating'

const AmbassadorStatisticsSection = ({ ambassador, toggleMissionsLimit }) => {
  const lastMissionDate = getLastMissionDateLabel(ambassador.missions)
  return (
    <AmbassadorSection className="statistics">
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <SectionTitle>Statistics</SectionTitle>
          </Col>
          <div
            style={{
              position: 'absolute',
              top: 40,
              right: 60,
              display: 'flex',
            }}
          >
            <label
              style={{
                display: 'inline-block',
                fontSize: 18,
                verticalAlign: 'middle',
                margin: 0,
                marginRight: 40,
                marginLeft: 20,
                fontWeight: 'normal',
              }}
            >
              3 missions per day
            </label>
            <Checkbox
              input={{
                onClick: toggleMissionsLimit,
                checked: ambassador.extendedMissionsLimit,
              }}
            />
          </div>
        </Row>
        <Row>
          <Col xs={3}>
            <p className="col-title">Member since</p>
            <p>
              {ambassador.memberSince
                ? moment(ambassador.memberSince).format('DD MMMM YYYY')
                : '-'}
            </p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Date of last completed mission</p>
            <p>{lastMissionDate}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title"># Flyers Distributed</p>
            <p>
              {ambassador.flyerCount != null
                ? numberFormatter(ambassador.flyerCount)
                : '-'}
            </p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Missions Completed</p>
            <p>
              {ambassador.missionCompletedCount != null
                ? numberFormatter(ambassador.missionCompletedCount)
                : '-'}
            </p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Rating (average)</p>
            <div className="rating">
              <StarRating
                id={ambassador.id}
                score={ambassador.rating}
                uniqueId={ambassador.id}
              />
              {ambassador.missionCompletedCount != null && (
                <span className="total">
                  ({ambassador.missionCompletedCount})
                </span>
              )}
            </div>
          </Col>
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default AmbassadorStatisticsSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/StatisticsSection/index.js